export default "__VITE_ASSET__hTQJSHEI__"